import { render, staticRenderFns } from "./QuotationGrades.vue?vue&type=template&id=1810e488"
import script from "./QuotationGrades.vue?vue&type=script&lang=js"
export * from "./QuotationGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports